// extracted by mini-css-extract-plugin
export default {"main":"Dashboard_main__l52uY","bg":"Dashboard_bg__niFwC","warning":"Dashboard_warning__5SMEH","warningText":"Dashboard_warningText__q4xcZ"};